import zIndex from "@mui/material/styles/zIndex";
import axios from "axios";
import { toast } from "react-toastify";

export const showToast = (type, message, position = "top-right") => {
  const commonOptions = {
    position, // Use the provided position or fallback to the default
    closeOnClick: true,
    theme: "light",
    pauseOnHover: false,
    autoClose: 1000,
    zIndex:1000,
    
  };

  toast[type](message, {
    ...commonOptions,
  });
};


export const handleGeocode = async (address) => {
  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: {
          address: address,
          key: process.env.NEXT_PUBLIC_API_KEY,
        },
      }
    );
    console.log(response, "responseeeeee");
    const { results } = response.data;
    if (results && results.length > 0) {
      const newAddressInfo = {};
      for (let add_part of results[0].address_components) {
        if (add_part.types.includes("administrative_area_level_1")) {
          newAddressInfo.state = add_part.long_name;
        }
        if (
          add_part.types.includes("postal_town") ||
          add_part.types.includes("locality")
        ) {
          newAddressInfo.city = add_part.long_name;
        }
        if (add_part.types.includes("postal_code")) {
          newAddressInfo.zipCode = add_part.long_name;
        }
        if (add_part.types.includes("route")) {
          newAddressInfo.street = add_part.long_name;
        }
      }

      return newAddressInfo
    } else {
      console.error("No results found");
    }
  } catch (error) {
    console.error("Error fetching geocoding data", error);
  }
};

export const extractTextInParentheses = (inputString) => {
  const regex = /\b[A-Z]{3}\b/;
  const match = inputString?.match(regex);
  return match ? match[0] : "";
};

export const getFlights = async (typeIata, airportIata, airline, flightNo) => {
  console.log(typeIata, airportIata, airline, flightNo, "dataaa");
  try {
    const currentProtocol = window.location.protocol;
    const apiEndpoint = "api.aviationstack.com/v1/flights";

    const flightDetails = await axios.get(
      `${currentProtocol}//${apiEndpoint}?access_key=80e979d2399e1fee889b1ab91f4b6ee8&${typeIata}=${airportIata}&airline_iata=${airline}&flight_number=${flightNo}`
    );
    return flightDetails;
  } catch (error) {
    console.log(error, "error");
  }
};

export const validateEmail = (email) => {
  // You can use a regular expression for basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const getTime = (time) => {
  const originalDate = new Date(time);

  // Format the date in 12-hour time format
  const formattedTime = originalDate.toUTCString();

  const dateObject = new Date(formattedTime);

  // Extract and format the time
  const extractedTime = dateObject.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "GMT",
  });

  // console.log(extractedTime,'extractedTime');
  return extractedTime;
};

export const formatCreditCardNumber = (number) => {
  // Remove all existing spaces and non-numeric characters
  const cleanedNumber = number.replace(/\D/g, "");

  // Determine the appropriate grouping based on the card number length
  const isAmex =
    cleanedNumber.startsWith("34") || cleanedNumber.startsWith("37");

  let formattedNumber;

  if (isAmex) {
    // American Express uses a 4-6-5 grouping
    formattedNumber = cleanedNumber
      .replace(/(\d{4})(\d{6})(\d{0,5})/, "$1 $2 $3")
      .trim();
  } else {
    // Most other cards use a 4-4-4-4 grouping
    formattedNumber = cleanedNumber
      .replace(/(\d{4})(\d{4})(\d{4})(\d{0,4})/, "$1 $2 $3 $4")
      .trim();
  }

  return formattedNumber;
};
